import React from 'react'

import EditTypeForm from '../../modules/Type/components/EditTypeForm'
export default function EditTypePage() {
  return <EditTypeForm />
}
